import { Steps } from 'antd';
import type { StepsProps } from 'antd';

// Antd v6 removed the <Steps.Step> children API; steps are passed via the `items` prop.
export default function EnhancedSteps(props: StepsProps) {
  return <Steps {...props} />;
}
